var monaco = require('./src/Monaco.vue')

module.exports = monaco



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-monaco-editor/index.js
// module id = ./node_modules/vue-monaco-editor/index.js
// module chunks = 1